
import { useContext, ref, reactive } from '@nuxtjs/composition-api'
import { Pages } from '~/assets/ts/pages'

export default {
  setup() {
    const {
      app: { i18n, router },
    } = useContext()

    let pageRoute = '' as string | null | undefined
    let pageName = '' as string
    let pageStr = '' as string

    const PagesHelper = new Pages()
    pageRoute = PagesHelper.getPageRoute(router)
    pageName = PagesHelper.getPageName(pageRoute)
    pageStr = PagesHelper.getPageStr(pageName)

    const currentQuestion = ref(1)

    const numberOfQuestions = 6

    const showNextQuestion = () => {
      if (process.client) {
        setTimeout(setNextQuestion, 500)
      }
    }

    const setNextQuestion = () => {
      currentQuestion.value++

      if (currentQuestion.value > numberOfQuestions) {
        calculateResult()
      }
    }

    const answers: { [key: string]: any } = reactive({
      1: {
        1: '0',
        2: '0',
        3: '0',
        4: '0',
        5: '0',
        6: '0',
        7: '0',
      },
      2: {
        1: '0',
        2: '0',
        3: '0',
        4: '0',
        5: '0',
        6: '0',
        7: '0',
      },
      3: {
        1: '0',
        2: '0',
        3: '0',
        4: '0',
        5: '0',
        6: '0',
        7: '0',
      },
      4: {
        1: '0',
        2: '0',
        3: '0',
        4: '0',
        5: '0',
        6: '0',
        7: '0',
      },
      5: {
        1: '0',
        2: '0',
        3: '0',
        4: '0',
        5: '0',
        6: '0',
        7: '0',
      },
      6: {
        1: '0',
        2: '0',
        3: '0',
        4: '0',
        5: '0',
        6: '0',
        7: '0',
      },
    })

    const answerSum: { [key: string]: number } = {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
    }

    const testResult = ref(0)

    const calculateResult = () => {
      for (const [, answersData] of Object.entries(answers)) {
        for (const [answersKey, answerValue] of Object.entries(answersData)) {
          if (answerValue === '1') {
            answerSum[answersKey]++
          }
        }
      }

      // get max test result
      const keys = Object.keys(answerSum)

      let maxKey = keys[0]
      let maxValue = answerSum[keys[0]]

      for (let i = 1; i < keys.length; i++) {
        const currentValue = answerSum[keys[i]]
        if (currentValue > maxValue) {
          maxKey = keys[i]
          maxValue = currentValue
        }
      }

      testResult.value = parseInt(maxKey)
    }

    const reset = () => {
      for (const [questionKey, answersData] of Object.entries(answers)) {
        for (const [answersKey, answerValue] of Object.entries(answersData)) {
          if (answerValue !== '0') {
            answers[questionKey][answersKey] = '0'
          }
        }
      }

      for (const key of Object.keys(answerSum)) {
        answerSum[key] = 0
      }

      currentQuestion.value = 1
      testResult.value = 0
    }

    return {
      i18n,
      pageRoute,
      pageName,
      pageStr,
      currentQuestion,
      showNextQuestion,
      answers,
      testResult,
      reset,
    }
  },
}
